
(function () {
  'use strict';

  const popup = document.getElementById('dli-newsletter-popup');
  if (!popup) return;

  const STORAGE_KEY = 'dli_popup_seen';
  const SUBSCRIBED_KEY = 'dli_popup_subscribed';

  const cfg = {
    trigger: popup.dataset.trigger || 'exit',
    delay: parseInt(popup.dataset.delay || '8', 10) * 1000,
    frequencyDays: parseInt(popup.dataset.frequency || '30', 10),
    mobile: popup.dataset.mobile === 'true',
    klaviyoKey: popup.dataset.klaviyoKey,
    klaviyoList: popup.dataset.klaviyoList,
  };

  const isMobile = window.matchMedia('(max-width: 640px)').matches;

  // ─── Frequency capping ────────────────────────────────────────
  function shouldShow() {
    if (!cfg.mobile && isMobile) return false;
    if (localStorage.getItem(SUBSCRIBED_KEY)) return false;

    const seen = localStorage.getItem(STORAGE_KEY);
    if (seen) {
      const daysSince = (Date.now() - parseInt(seen, 10)) / (1000 * 60 * 60 * 24);
      if (daysSince < cfg.frequencyDays) return false;
    }
    return true;
  }

  function markSeen() {
    localStorage.setItem(STORAGE_KEY, Date.now().toString());
  }

  // ─── Open / close ─────────────────────────────────────────────
  let opened = false;
  function open() {
    if (opened || !shouldShow()) return;
    opened = true;
    popup.classList.add('is-open');
    popup.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    setTimeout(() => {
      const input = popup.querySelector('.dli-popup__input');
      if (input) input.focus();
    }, 100);
  }

  function close() {
    popup.classList.remove('is-open');
    popup.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    markSeen();
  }

  popup.querySelectorAll('[data-close]').forEach(el => {
    el.addEventListener('click', close);
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && popup.classList.contains('is-open')) close();
  });

  // ─── Triggers ─────────────────────────────────────────────────
  if (!shouldShow()) return;

  if (cfg.trigger === 'exit') {
    // Exit intent (desktop). Fallback til 25s på mobil.
    if (isMobile) {
      setTimeout(open, 25000);
    } else {
      const onLeave = (e) => {
        if (e.clientY <= 0) {
          open();
          document.removeEventListener('mouseleave', onLeave);
        }
      };
      document.addEventListener('mouseleave', onLeave);
      // Backup: vis alligevel efter 60s hvis exit ikke trigges
      setTimeout(open, 60000);
    }
  } else if (cfg.trigger === 'time') {
    setTimeout(open, cfg.delay);
  } else if (cfg.trigger === 'scroll') {
    const onScroll = () => {
      const scrolled = (window.scrollY + window.innerHeight) / document.body.scrollHeight;
      if (scrolled >= 0.5) {
        open();
        window.removeEventListener('scroll', onScroll);
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  // ─── Submit til Klaviyo ───────────────────────────────────────
  const form = popup.querySelector('.dli-popup__form');
  const errorEl = popup.querySelector('.dli-popup__error');
  const successEl = popup.querySelector('.dli-popup__success');

  function showError(msg) {
    errorEl.textContent = msg;
    errorEl.hidden = false;
  }

  function clearError() {
    errorEl.hidden = true;
    errorEl.textContent = '';
  }

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    clearError();

    const email = form.email.value.trim();
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      showError('Indtast venligst en gyldig e-mailadresse.');
      return;
    }

    if (!cfg.klaviyoKey || !cfg.klaviyoList) {
      console.error('[DLI Popup] Klaviyo key eller list ID mangler i theme settings.');
      showError('Noget gik galt. Prøv igen senere.');
      return;
    }

    popup.classList.add('is-loading');
    form.querySelector('.dli-popup__submit').disabled = true;

    try {
      // Klaviyo Client API — Subscribe Profiles
      // Docs: https://developers.klaviyo.com/en/reference/subscribe_profiles
      const payload = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'popup_v1',
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                  properties: {
                    signup_source: 'popup_v1',
                    signup_variant: 'A',
                  },
                },
              },
            },
          },
          relationships: {
            list: {
              data: { type: 'list', id: cfg.klaviyoList },
            },
          },
        },
      };

      const res = await fetch(
        `https://a.klaviyo.com/client/subscriptions/?company_id=${cfg.klaviyoKey}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'revision': '2024-10-15',
          },
          body: JSON.stringify(payload),
        }
      );

      if (!res.ok && res.status !== 202) {
        const data = await res.json().catch(() => ({}));
        throw new Error(data?.errors?.[0]?.detail || 'Tilmelding fejlede');
      }

      // Success
      form.hidden = true;
      successEl.hidden = false;
      localStorage.setItem(SUBSCRIBED_KEY, '1');
      markSeen();

      // Track event til Klaviyo (valgfrit)
      if (window._learnq) {
        window._learnq.push(['identify', { '$email': email }]);
        window._learnq.push(['track', 'Signed Up From Popup', {
          source: 'popup_v1',
          variant: 'A',
        }]);
      }

      // Auto-close efter 3 sek
      setTimeout(close, 3500);

    } catch (err) {
      console.error('[DLI Popup] Klaviyo submit fejlede:', err);
      showError('Noget gik galt. Prøv venligst igen.');
    } finally {
      popup.classList.remove('is-loading');
      form.querySelector('.dli-popup__submit').disabled = false;
    }
  });

})();